import { CheckCircle, XCircle } from '@styled-icons/boxicons-regular';

function FeaturesList({ data }) {
  return (
    <div className="features-container">
      {data.map((item) => (
        <div
          className={`feature ${item.isDisabled ? 'disabled' : ''}`}
          key={item.id}
        >
          <div className="icon">
            {item.isDisabled ? (
              <XCircle size={20} />
            ) : (
              <CheckCircle size={20} />
            )}
          </div>
          <div className={['content', item.className || ''].join(' ')}>
            {item.Component}
          </div>
        </div>
      ))}
    </div>
  );
}

export default FeaturesList;
